<div class="container">
  <div class="loader" *ngIf="loading"></div>

  <div *ngIf="mode == 'EDIT' && !loading" class="animate__animated animate__fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top shadow-sm">
      <div class="container-fluid">
        <span class="navbar-text">
          Proceso de Compra
        </span>
        <div class="pull-right">
          <button class="btn btn-secondary me-1" (click)="cancelEvent()">
            Cerrar
          </button>
          <button class="btn btn-primary" (click)="saveEvent()" *mtHasPermission="['ADMIN_BUDGET_FORMS', 'MANAGE_PURCHASE', 'MANAGE_BUDGET_FORMS']">
            Guardar
          </button>
        </div>
      </div>
    </nav>

    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label" for="purchaseRequest">Solicitud de Compra</label>

        <ng-select class="mt-large-ng-select custom"
                   name="purchaseRequest" id="purchaseRequest"
                   [(ngModel)]="model.purchaseRequest" [appendTo]="'body'" title="Solicitud de compra" *ngIf="!model.id" (change)="onPurchaseRequestChange()">
          <ng-option *ngFor="let pr of purchaseRequests" [value]="pr.id">{{pr.initialDecisionCode}}</ng-option>
        </ng-select>


        <input *ngIf="model.id" type="text" class="form-control" id="purchaseRequestCode" name="purchaseRequestCode" [ngModel]="selectedPurchaseRequest?.initialDecisionCode" readonly>
        <div *ngIf="formErrors.get('purchaseprocess.purchaseRequest')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaseprocess.purchaseRequest') }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label" for="selectedRequestAmount">Monto de Solicitud</label>
        <input type="number" class="form-control" id="selectedRequestAmount" name="selectedRequestAmount" [ngModel]="selectedRequestAmount" readonly [disabled]="true">
      </div>
      <div class="col-md-4">
        <label class="form-label" for="purchaseAmount">Monto de Compra Total</label>
        <input type="number" class="form-control" id="purchaseAmount" name="purchaseAmount" [(ngModel)]="model.purchaseAmount" readonly [disabled]="true">
        <div *ngIf="formErrors.get('purchaseprocess.purchaseAmount')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaseprocess.purchaseAmount') }}
        </div>
      </div>
    </div>

    <div class="card mb-3" *ngIf="model.lines && model.lines.length > 0">
      <div class="card-header">
        Líneas de Compra
      </div>
      <div class="card-body">
        <div *ngFor="let line of model.lines; let i = index" class="row mb-2 align-items-end">
          <div class="col-md-7">
            <label class="form-label" *ngIf="i === 0">Monto Solicitud por Cuenta</label>
            <div class="input-group">
              <span class="input-group-text" title="{{line.accountName}}"> {{line.accountCode}}</span>
              <input type="number" class="form-control" [value]="getAmountToCommit(line.purchaseRequestLine)" readonly disabled>
            </div>
          </div>
          <div class="col-md-5">
            <label class="form-label" *ngIf="i === 0">Monto de Compra</label>
            <input type="number" class="form-control" [(ngModel)]="line.purchaseAmount" (change)="calculateTotal()" name="purchaseAmount_{{i}}" [disabled]="isAmountDisabled()">
            <div *ngIf="formErrors.get('purchaseprocess.lines[' + i + '].purchaseAmount')" class="badge bg-danger animated fadeIn">
              {{ formErrors.get('purchaseprocess.lines[' + i + '].purchaseAmount') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label" for="sicopNumber">Número SICOP</label>
        <input type="text" class="form-control" id="sicopNumber" name="sicopNumber" [(ngModel)]="model.sicopNumber">
        <div *ngIf="formErrors.get('purchaseprocess.sicopNumber')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaseprocess.sicopNumber') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="status">Estado</label>
        <select class="form-select" id="status" name="status" [(ngModel)]="model.status" [disabled]="!model.id">
          <option *ngFor="let status of getAvailableStatuses()" [value]="status">{{statusLabels[status]}}</option>
        </select>
        <div *ngIf="formErrors.get('purchaseprocess.status')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaseprocess.status') }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label" for="awardDate">Fecha de Adjudicación</label>
        <mt-date-picker [(date)]="model.awardDate" name="awardDate" id="awardDate" label="Fecha de Adjudicación" [disabled]="isAwardDateDisabled()"/>
        <div *ngIf="formErrors.get('purchaseprocess.awardDate')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaseprocess.awardDate') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="unsuccessfulDate">Fecha Infructuoso/Desierto</label>
        <mt-date-picker [(date)]="model.unsuccessfulDate" name="unsuccessfulDate" id="unsuccessfulDate" label="Fecha Infructuoso/Desierto" [disabled]="isUnsuccessfulDateDisabled()"/>
        <div *ngIf="formErrors.get('purchaseprocess.unsuccessfulDate')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaseprocess.unsuccessfulDate') }}
        </div>
      </div>
    </div>

    <div *ngIf="model.documents && model.documents.length > 0" class="row mb-3 mt-4">
      <div class="col-12">
        <h5>Documentos Asociados</h5>
        <table class="table table-sm">
          <thead>
          <tr>
            <th>Código</th>
            <th>Emisor</th>
            <th>Fecha</th>
            <th>Total</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let doc of model.documents">
            <td>{{doc.sequence}}</td>
            <td>{{doc.issuer}}</td>
            <td>{{doc.date}}</td>
            <td>{{doc.total | currency:'CRC'}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="mode == 'LIST' && !loading" class="animate__animated animate__fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top shadow-sm">
      <div class="container-fluid">
        <form class="d-flex">
          <div class="flex-grow-1 me-2">
            <input type="text" class="form-control" [(ngModel)]="searchText" name="searchText"
                   placeholder="Buscar..." (change)="searchEvent()"/>
          </div>
          <div class="me-2">
            <select class="form-select" [(ngModel)]="selectedStatus" name="selectedStatus" (change)="searchEvent()">
              <option value="">Todos los estados</option>
              <option *ngFor="let status of statusLabels | keyvalue" [value]="status.key">{{status.value}}</option>
            </select>
          </div>
        </form>
        <div class="pull-right">
          <button class="btn btn-secondary me-1" (click)="refreshEvent()" title="Refrescar">
            <span class="fa fa-sync fa-lg"></span>
          </button>
          <button class="btn btn-primary" (click)="createEvent()" title="Agregar">
            Agregar
          </button>
        </div>
      </div>
    </nav>

    <mt-pagination (loadPage)="getPageEvent($event)" [page]="page"></mt-pagination>

    <table *ngIf="page.metadata.pages > 0" class="table table-hover">
      <thead>
      <tr>
        <th>Número SICOP</th>
        <th>Monto de Compra</th>
        <th>Fecha de Adjudicación</th>
        <th>Fecha Infructuoso/Desierto</th>
        <th>Estado</th>
        <th class="mt-actions-col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pp of page.content">
        <td (click)="editEvent(pp)" class="mt-content-col">
          {{pp.sicopNumber}}
        </td>
        <td (click)="editEvent(pp)">
          {{pp.purchaseAmount | currency:'CRC'}}
        </td>
        <td (click)="editEvent(pp)">
          {{pp.awardDate}}
        </td>
        <td (click)="editEvent(pp)">
          {{pp.unsuccessfulDate}}
        </td>
        <td (click)="editEvent(pp)">
          {{pp.status ? statusLabels[pp.status] : ''}}
        </td>
        <td class="mt-actions-col">
          <button class="btn btn-link btn-lg pull-right" data-bs-toggle="modal" data-bs-target="#removePPConfirmation"
                  (click)="selectEvent(pp)" title="Borrar" *mtHasPermission="['ADMIN_BUDGET_FORMS']">
            <span class="fa fa-trash-alt fa-lg"></span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div *ngIf="page.metadata.pages == 0">
      No hay registros
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="removePPConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el registro?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeEvent(model)">Borrar</button>
        </div>
      </div>
    </div>
  </div>
</div>
